import { render, staticRenderFns } from "./IEPage.vue?vue&type=template&id=24ba39d0"
import script from "./IEPage.vue?vue&type=script&lang=js"
export * from "./IEPage.vue?vue&type=script&lang=js"
import style0 from "./IEPage.vue?vue&type=style&index=0&id=24ba39d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports